$(document).ready(() => {
  $(".nav__list-item").hover(function() {
    var isHovered = $(this).is(":hover");
    if (isHovered) {
      $(this).addClass('hovered').children("ul").addClass('open');
    } else {
      $(this).removeClass('hovered').children("ul").removeClass('open');
    }
  });
  $(".filter-wrapper-toggle").on("click", () => {
    $(".filter-wrapper").toggleClass("hidden")
    if ($(".filter-wrapper-toggle").text() === 'VISA FILTER') {
      $(".filter-wrapper-toggle").text('DÖLJ FILTER');
    } else {
      $(".filter-wrapper-toggle").text('VISA FILTER');
    }
  });
  $(".search input").on('focus', () => $('.header').addClass('search-open'));
  $(".search input").on('blur', () => $('.header').removeClass('search-open'));
  $(".hamburger-menu__list-item > a").on('click', (e) => { if ($(e.target).siblings('div').length) { $(e.target).siblings('div').addClass('open');} })
  $(".back").on('click', (e) => { $(e.target).parents('.scroller').removeClass('open'); })
  var w = $(".video__container video").width();
  $(".video__container video").css("height", (w/16)*9 );
});

$(window).resize(function(){
  var w = $(".video__container video").width();
  $(".video__container video").css("height", (w/16)*9 );
});

$(".video__container #video").on("ended", function (e) {
  $(".video__container #play_button").removeClass("play");
  $(".video__container #video").get(0).load();
});

$(".video__container #play_button").click(function() {
  $(this).toggleClass("play");
  if($(".video__container #video").get(0).paused || $(".video__container #video").get(0).ended){
    $(".video__container #video").get(0).play();
  }else{
    $(".video__container #video").get(0).pause();
  }
});

$(".video__container #video").on("play", function (e) {
  $(".video__container").click(function() {
    $(".video__container #video").get(0).pause();
    $(".video__container").addClass("paused");
    $(".video__container #play_button").removeClass("play");
  });
});

$(".video__container #video").on("pause", function (e) {
  $(".video__container").click(function() {
    $(".video__container #video").get(0).play();
    $(".video__container").removeClass("paused");
    $(".video__container #play_button").addClass("play");
  });
});

$(".template-page .iwt__container .iwt-block .iwt__image-block").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<div class="arrow-left"><img src="//toniton.se/cdn/shop/t/27/assets/larr.svg?v=111515263851917843691761904501"></div>',
  nextArrow: '<div class="arrow-right"><img src="//toniton.se/cdn/shop/t/27/assets/rarr.svg?v=2442803647094798791761904501"></div>'
});
